import { Box } from '@mui/material';
import DurationMonitorComponent from "./components/DurationMonitorComponent";
import AmplitudeMonitorComponent from "./components/AmplitudeMonitorComponent";
import VerticalSwitch from "../../ui/VerticalSwitch";
import useStore from "../../../store/store";
import React from "react";
import Typography from "@mui/material/Typography";
import style from './rectangular.css';

export default function RectangularPulseGenerator() {

    const toggleGenerator = useStore((state) => state.toggleGenerator);

    const activeExitGenerator = useStore((state) => state.activeExitGenerator);
    const activeEnterOcsilloscope = useStore((state) => state.activeEnterOcsilloscope);
    const activeEnterMembrane = useStore((state) => state.activeEnterMembrane);
    const activeExitMembrane = useStore((state) => state.activeExitMembrane);

    const changeActiveExitMembrane = useStore((state) => state.changeActiveExitMembrane);
    const changeActiveEnterOcsilloscope = useStore((state) => state.changeActiveEnterOcsilloscope);
    const changeActiveEnterMembrane = useStore((state) => state.changeActiveEnterMembrane);
    const changeActiveExitGenerator = useStore((state) => state.changeActiveExitGenerator);

    const resetAllWires = useStore((state) => state.resetAllWires);
    const resetFullWires = useStore((state) => state.resetFullWires);

    const changeExitGenerator_EnterMembrane = useStore((state) => state.changeExitGenerator_EnterMembrane);
    const changeExitMembrane_enterOcsilloscope = useStore((state) => state.changeExitMembrane_enterOcsilloscope);



    const changeActiveExitGenerator1Handle = () => {
        if (!activeEnterMembrane && !activeEnterOcsilloscope && !activeExitMembrane){
            changeActiveExitGenerator()
        }

        if (!activeEnterMembrane && (activeEnterOcsilloscope || activeExitMembrane)){
            alert ('не правильно з\'єднали!')
            resetFullWires()
        }

        if (activeEnterMembrane){
            changeActiveExitGenerator()
            changeExitGenerator_EnterMembrane()
            resetAllWires()
        }
    }

    const eng = useStore((state) => state.eng);



    return (
        <Box className="rectangular">
            <Box className="titleMain">
                <Box className="titleMainText">{eng ? 'Rectangular pulse generator' : 'Генератор прямокутних імпульсів'}</Box>
            </Box>
            <Box className="mainComponents">
                <DurationMonitorComponent eng={eng} />
                <AmplitudeMonitorComponent eng={eng} />

                <Box className="toggleSector">
                    <VerticalSwitch onChange={toggleGenerator} />
                    <Box className="togglerText">
                        {eng ? 'Off' : 'Викл'}
                    </Box>
                    <Box className="toggler">
                        <Typography>{eng ? 'Exit' : 'Bихід'}</Typography>
                        <Box
                            className="toggleButton"
                            onClick={changeActiveExitGenerator1Handle}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
